export default "__VITE_ASSET__7kHoSuX8__"